import "../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { PedidosHistorialContext } from '../../../context/pedidoshistorial/PedidosHistorialContext';
import { Paginator } from '../../../components/paginator/Paginator';
import { headers } from "./configGrid/headers";
import { formatRows } from "./configGrid//rows";
import { indice } from "../../../components/DataGrid/indice";
import { getActionColumn } from "../../../components/ActionesColumns/ActionColumns";
import CircularProgress from "@mui/material/CircularProgress";
import useDocumentTitle from "../../../components/Title";
import CustomDataGrid from "../../../components/DataGrid/CustomDataGrid";
import ConfirmDialog from "../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData } from './configGrid/apiCalls';
import FiltersGrid from './filtersGrid/filtersGrid';
import { useFilters } from "../../../context/FiltersContext";

export const Datatable = () => {
  const titleGrid = "Historial de Pedidos"
  useDocumentTitle(titleGrid);
  const { updateFilters, getFilters } = useFilters();
  const contexto = useContext(PedidosHistorialContext);
  const { getPedidosHistorialPanelData } = contexto;
  const navigate = useNavigate();
  const nameData = "pedidosHistorial";
  const getData = getPedidosHistorialPanelData;
  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Estado del buscador
  const [searchIDCli, setSearchIDCli] = useState();
  const [searchDescCli, setSearchDescCli] = useState();
  const [searchIDEmp, setSearchIDEmp] = useState();
  const [searchDescEmp, setSearchDescEmp] = useState();
  const [dateFrom, setDateFrom] = useState("");
  const [dateUntil, setDateUntil] = useState("");
  // Ref para busqueda
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el Modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  //Estado General de Filtros en LocalStorage
  const [isInitialized, setIsInitialized] = useState(false);
  const pageKey = "historial";
  // 🔹 Obtenemos los filtros persistidos
  const filters = getFilters(pageKey) || {
    searchIDCli: "",
    searchDescCli: "",
    searchIDEmp: "",
    searchDescEmp: "",
    dateFrom: "",
    dateUntil: "",
  };

  useEffect(() => {
    const savedFilters = getFilters(pageKey);

    if (savedFilters) {
      setSearchIDCli(savedFilters.searchIDCli || "");
      setSearchDescCli(savedFilters.searchDescCli || "");
      setSearchIDEmp(savedFilters.searchIDEmp || "");
      setSearchDescEmp(savedFilters.searchDescEmp || "");
      setDateFrom(savedFilters.dateFrom || "");
      setDateUntil(savedFilters.dateUntil || "");
    }

    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (!isInitialized) return;
    fetchData();
    loadFilters();
  }, [isInitialized, searchIDCli, searchIDEmp, dateFrom, dateUntil, numPagina, filas]);

  // 🔹 Función segura para actualizar filtros
  const loadFilters = () => {
    const updatedFilters = {
      searchIDCli,
      searchDescCli,
      searchIDEmp,
      searchDescEmp,
      dateFrom,
      dateUntil,
    };
    updateFilters(pageKey, updatedFilters);
  };

  // Dentro del componente `Datatable`
  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity, totalItems, totalPage } = await fetchEntityData(
        getData,
        searchIDCli || "",
        searchIDEmp || "",
        dateFrom || "",
        dateUntil || "",
        numPagina,
        filas
      );
      if (numPagina > totalPage) {
        setNumPagina(totalPage);
      } else {
        setListaItems(dataEntity);
        setTotalItems(totalItems);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const openModal = (id) => {
    setSelectedItem(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const handleClickEdit = (e) => {
    if (e) navigate(`/${nameData}/new/${e}`);
  };

  const getDynamicValue = (row, key) => {
    return row[key];
  };

  // Dentro de la función Datatable...
  const datosColum = useMemo(() => {
    const commonCols = indice(numPagina, filas).concat(headers.filter((column) => !column.hidden));
    return commonCols.concat(getActionColumn(handleClickEdit, openModal, false));
  }, [numPagina, filas]);

  const rows = useMemo(() => formatRows(listaItems), [listaItems]);

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <h3>{titleGrid}</h3>
        <FiltersGrid
          searchDescFilter={searchDescCli}
          searchSecondDescFilter={searchDescEmp}
          setSearchIDFilter={setSearchIDCli}
          setSearchDescFilter={setSearchDescCli}
          setSearchSecondIDFilter={setSearchIDEmp}
          setSearchSecondDescFilter={setSearchDescEmp}
          dateFromFilter={dateFrom}
          dateUntilFilter={dateUntil}
          setDateFromFilter={setDateFrom}
          setDateUntilFilter={setDateUntil}
        />
      </div>
      {(isLoading) ? (
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
            <h1>Cargando datos...</h1>
            <CircularProgress />
          </div>
        </div>
      ) : (
        <>
          <div className="datagridWrapper">
            <CustomDataGrid
              rows={rows}
              columns={datosColum}
              pageSize={filas}
              rowCount={totalItems}
              enableSelectionClick={false}
              onPageChange={setNumPagina}
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1);
              }}
              isLoading={isLoading}
            />
          </div>
          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>
          <ConfirmDialog
            open={isModalOpen}
            onClose={closeModal}
            nameData={nameData}
          />

          <ErrorDialog
            open={isErrorDialogOpen}
            onClose={closeErrorDialog}
            errormessages={errorMessage}
          />
        </>

      )}
    </div>
  );
};

export default Datatable;
